import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, switchMap, throwError } from 'rxjs';
import { promotionConstants } from '../shared/ocado-constants';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { OcadoAuthService } from '../shared/service/auth.service';
import { SharedService } from '../shared/service/shared.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const ocadoAuthService = inject(OcadoAuthService);
  const sharedService = inject(SharedService);
  const app_token = ocadoAuthService.appToken;
  const authReq = req.clone({
    headers: req.headers.set('Authorization', app_token)
  });
  const errorCodes = promotionConstants.errorCodes;
  return next(authReq).pipe(
    catchError((err: any) => {
      if (err instanceof HttpErrorResponse) {
        if (err.error.error === errorCodes.userNotExists || err.error.error === errorCodes.roleNotExists ||
          err.error.error === errorCodes.errUnAuth) {
          router.navigate([ 'unauthorised' ]);
        }
        if (err.error.error === errorCodes.criticalIssue || err.error.error === errorCodes.nightlyBatch ||
          err.error.error === errorCodes.systemMaintenance) {
          ocadoAuthService.isStaff = err.error.result.is_staff;
          sharedService.activeApplicationDetails.next([]);
          ocadoAuthService.isNightlyBatch.next(true);
          router.navigate([ 'system-maintenance' ]);
        }
        if (err.error.error === errorCodes.errTokenExp) {
          if (!ocadoAuthService.isRefreshTokenFetched.value) {
            ocadoAuthService.isRefreshTokenFetched.next(true);
            console.log("error-token");
            if (!req.url.endsWith('getTokenWithRole')) {
              return ocadoAuthService.getAccessToken().pipe(
                switchMap(data => {
                  if (data) {
                    const new_app_token = ocadoAuthService.appToken;
                    const retryReq = req.clone({
                      headers: req.headers.set('Authorization', new_app_token)
                    });
                    return next(retryReq);
                  } else {
                    console.error('Failed to refresh token. Logging out...');
                    // this.auth.logout(); // Logout if refresh fails
                    return throwError(() => new Error('Token refresh failed'));
                  }
                })
              );
            } else {
              console.log("what to do");
              ocadoAuthService.logout();
            }
          }
        }
        if (err.error.error === errorCodes.backChannelLogout) {
          console.log("Back Channel Logout");
          ocadoAuthService.logout();
        }
      }
      return throwError(() => err);
    }));
};
